export default __webpack_public_path__ + "static/media/a023-04.7b1f691d.png";